import gql from 'graphql-tag'

export default gql`
    query LoadOrderProcessData($type: String!) {
        loadOrderProcessData(type: $type) {
            globalConfiguration {
                title
                showBasketInfoIcons
                enableWelcomePage
                useCustomCombiDefaultSelection
                enablePresentation
                enableHardwareSelection
                logoClickWebsite
                showFooterLogo
                footer {
                    i18Key
                    link
                }
                icons {
                    header
                    footer
                    thankYou
                }
                secondFactorOrderConfirmationEnable
                secondFactorOrderConfirmationType
            }
            voucherConfiguration {
                enableAutomatic
                enableManual
            }
            portabilityConfiguration {
                contractHolderMaximumNumber
                portabilityMaximumNumber
                previousProvider
                previousContractHolder
                previousContractAddress
                previousContractTermination
                showPortability {
                    identifier
                    wishValue
                }
                B2BpreviousContractTerminationLink
                B2CpreviousContractTerminationLink
            }
            productCategoriesConfiguration {
                id
                config {
                    excluded
                    required
                }
            }
            telephoneOptions {
                enablePage
                telephoneConfiguration {
                    identifier
                    link {
                        text
                        url
                    }
                    helpText
                    required
                    type
                    displayType
                    options {
                        labelKey
                        value
                        preselected
                    }
                    condition {
                        identifier
                        value
                    }
                    render {
                        identifier
                        link {
                            text
                            url
                        }
                        helpText
                        required
                        type
                        displayType
                        options {
                            labelKey
                            value
                            preselected
                        }
                        condition {
                            identifier
                            value
                        }
                        noMarginBottom
                        marginTop
                        titleHidden
                    }
                    noMarginBottom
                    marginTop
                    titleHidden
                }
            }
            installationConfiguration {
                enablePage
                minInstallationDate
                maxInstallationDate
            }
            installationDetailsConfiguration {
                enablePage
                appartmentData {
                    floorInformation
                    floorInformationRequired
                    floorInformationRequiredIf
                    flatPosition
                    flatPositionRequired
                    flatPositionRequiredIf
                    flatNumber
                    flatNumberRequired
                    flatNumberRequiredIf
                }
                junctionBox {
                    identifier
                    title
                    preselected
                    options {
                        title
                        badgeIdentifier
                        information
                    }
                }
                houseConnection {
                    identifier
                    title
                    preselected
                    options {
                        title
                        badgeIdentifier
                        information
                    }
                }
                opticFiber {
                    identifier
                    title
                    preselected
                    options {
                        title
                        badgeIdentifier
                        information
                    }
                }
                installationService {
                    title
                    subtitle
                    video
                    option {
                        title
                        subtitle
                        cost
                        information
                    }
                }
            }
            bankDetails {
                enablePage
                consentLabel {
                    selfAccountHolder
                    differentAccountHolder
                }
                useSecondConsentIBAN
                useInvoiceFee {
                    feeId
                    visibleB2B
                }
                useTransferFee {
                    feeId
                    visibleB2B
                }
                displayIBAN
                displayTransfer
                displayDayOfTransfer
                preselected
                invoiceSend {
                    display
                    enableOptionMail
                    enableOptionEmail
                }
            }
            withdrawalConfiguration {
                enableButton
            }
            orderOverview {
                vzf {
                    header
                    subheader
                    helperText
                    checkboxes
                }
                legalTerms {
                    header
                    subheader
                    helperText
                    checkboxes {
                        value
                        isDisplayedInB2B
                    }
                }
                newsletters {
                    header
                    subheader
                    helperText
                    checkboxes
                }
                sendOverView {
                    header
                    subheader
                    helperText
                    checkboxes
                }
                showPeriodOfNoticeInfo
                showRightOfWithdrawalInfo
                isEditable
            }
            noProductAvailable {
                haveLink
                link
                redirectURL
                redirectNewTab
            }
            vzfConfiguration {
                optionalFees {
                    name
                    value
                }
                footNoteText {
                    name
                    value
                }
                introText
            }
            contactDataViewConfiguration {
                enablePage
                activateSalesPartnerEmail
                salesPartnerEmail
                enableCompanyTaxID
                enableLegalForm
                enableCompanyRegisterEntry
                enableCompanyLocation
                enableAlternativeLegalForm
                enableDeviatingDeliveryAddress
                enableOptionalComment
                enableOptionalCommentSalesParter
            }
            orderConfirmationConfiguratiuon {
                enableTouchPoints
                touchPoints {
                    label
                    hasInput
                }
            }
            optList
            crossSelling {
                enabledPage
                rules {
                    target
                    required
                }
            }
            productExcludeList
        }
    }
`
